import React, { useState } from 'react';
import { BsPrinter } from 'react-icons/bs';
import { IoMdPaperPlane } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Divider, HStack, Icon, IconButton, Text, useToast } from '@chakra-ui/react';
import { Parser } from 'html-to-react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../../../constants/analyticsIds';
import { resendEmail, selectInsuredEmail } from '../../../../../redux/modules/insured';
import { hideModal } from '../../../../../redux/modules/modal';
import colors from '../../../../../styles/theme/foundation/colors';
import { formatDateTimeToClientLocal } from '../../../../../utils/dateUtil';

import EmailDetailRow from './EmailDetailRow';

import './styles.css';

const ViewEmailModal = ({ email, ...boxProps }) => {
  const [isSubmitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();
  const htmlParser = new Parser();
  const convertedDate = formatDateTimeToClientLocal(email.createdAt);
  const parsedBodyMessage = htmlParser.parse(email.body);

  const handleResendEmail = () => {
    setSubmitting(true);

    const onSuccess = () => {
      dispatch(hideModal());
      setSubmitting(false);
    };

    const onFail = () => setSubmitting(false);

    dispatch(resendEmail(email.id, onSuccess, onFail));
  };

  return (
    <Box id="print-email-div" {...boxProps}>
      <Box py={2}>
        <HStack
          alignItems="center"
          justifyContent="space-between"
        >
          <Text
            color={colors.greyScale['900']}
            maxW="75%"
            mr={4}
            overflow="hidden"
            textOverflow="ellipsis"
            textStyle="bodyXl500"
            whiteSpace="nowrap"
          >
            {email.subject}
          </Text>
          <HStack gap={4}>
            <Button
              data-analytics-id={analyticsIds.insuredProfilePage.policiesComponent.emailHistoryTray.resendEmailButton}
              isLoading={isSubmitting}
              leftIcon={<Icon as={IoMdPaperPlane} boxSize={6} />}
              loadingText="Sending"
              variant="primary"
              width="148px"
              onClick={() => handleResendEmail()}
            >
              <Text>Send Again</Text>
            </Button>
            <IconButton
              data-analytics-id={analyticsIds.insuredProfilePage.policiesComponent.emailHistoryTray.printEmailButton}
              icon={<Icon as={BsPrinter} boxSize={6} />}
              variant="accent"
              onClick={() => window.print()}
            />
          </HStack>
        </HStack>
      </Box>

      <Box py={6}>
        <EmailDetailRow details={convertedDate} title="Date" />
        <EmailDetailRow details={email.from} title="From" />
        <EmailDetailRow details={email.to} title="To" />
        <EmailDetailRow details={email.cc} title="Cc" />
        <EmailDetailRow details={email.bcc} title="Bcc" />
      </Box>

      <Divider />

      <Box py={6}>
        <div>{parsedBodyMessage}</div>
      </Box>
    </Box>
  );
};

ViewEmailModal.propTypes = {
  email: PropTypes.shape({
    id: PropTypes.number,
    date: PropTypes.string,
    createdAt: PropTypes.string,
    body: PropTypes.string,
    to: PropTypes.string,
    subject: PropTypes.string,
    jobName: PropTypes.string,
    senderType: PropTypes.string,
    sender: PropTypes.shape({
      userFirstName: PropTypes.string,
      userLastName: PropTypes.string
    })
  }).isRequired
};

export default ViewEmailModal;
